import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { PubOwnerDomain, PubOwnerRole } from "../../api/cafe";
import { pubState } from "../../recoil/pub.atom";
import EditBackgroundColor from "./components/edit/color";
import EditAllInfo from "./components/edit/info";
import EditTemplate from "./components/edit/template";
import Preview from "./components/preview";
import PosterMakerTab from "./components/tab";
import TournamentList from "./components/tournamentList";
import { PosterProvider, usePosterContext } from "./context/poster-context";
import { PosterTab } from "./hooks/use-poster";
import {
  PosterMakerLeftWrapper,
  PosterMakerRightWrapper,
  PosterMakerTitle,
  PosterMakerWrapper,
} from "./styles";

const PosterMakerContent = () => {
  const { selectedTournament, tab } = usePosterContext();
  const pub = useRecoilValue(pubState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.MARKETING)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  return (
    <PosterMakerWrapper>
      {/* left wrapper */}
      <PosterMakerLeftWrapper>
        <PosterMakerTitle>포스터 생성</PosterMakerTitle>
        <PosterMakerTab />
        {tab === PosterTab.TEMPLATE ? <EditTemplate /> : null}
        {tab === PosterTab.COLOR ? <EditBackgroundColor /> : null}
        {tab === PosterTab.INFO ? <EditAllInfo /> : null}
      </PosterMakerLeftWrapper>
      {/* right wrapper */}
      <PosterMakerRightWrapper>
        <PosterMakerTitle>
          {selectedTournament ? "미리보기" : "토너먼트 목록"}
        </PosterMakerTitle>
        {selectedTournament ? <Preview /> : <TournamentList />}
      </PosterMakerRightWrapper>
    </PosterMakerWrapper>
  );
};

const PosterMaker = () => {
  return (
    <PosterProvider>
      <PosterMakerContent />
    </PosterProvider>
  );
};

export default PosterMaker;
